import React, { useState } from 'react';
import axios from 'axios';
import { servicios_grupogack_rh, cambios_no_guardados } from '../../../../../../../Constants/Constants';
import { headersAuth } from '../../../../../../../Services/AuthService';
import { JsonMovimientosEmpleado } from '../../../../Helpers/JsonToOneLevel';
import ModalService from '../../../../ModalService/ModalService';
import AlertForm from '../../../../../../../Services/AlertForm';
import FormularioVariables from './FormularioVariables';

const ModalEditMovimientos = ({ openEdit, setOpenEdit, elementSelect, editar, errorTable, informacionAdicional, idModulo }) => {
    const [ error, setError ] = useState( null );
    const cerrarModal = () => {
        setOpenEdit( false );
        setError( null );
    }

    const actualizarMovimiento = ( movimiento, movimientoID ) => {
        axios.put( `${servicios_grupogack_rh}/movimientos/${movimientoID}`, movimiento, headersAuth() )
            .then( respuesta => {
                switch( respuesta.data.status ){
                    case 200:
                        editar( JsonMovimientosEmpleado( respuesta.data.dataResponse ) );
                        setOpenEdit( false );
                        break;
                    case 400:
                        setError( <AlertForm message={ respuesta.data.msg } /> );
                        break;
                    default:
                        errorTable( cambios_no_guardados );
                        break;
                }
            })
            .catch( error => {
                errorTable( cambios_no_guardados );
            })
    }

    return (
        <ModalService title="Actualizar Movimiento Variable" parentNode={idModulo} minWidth="40%"
            isOpen={ openEdit } onClose={ () => cerrarModal() } >
                <FormularioVariables
                    error={error}
                    elementSelect={elementSelect}
                    informacion={informacionAdicional}
                    actualizarMovimiento={actualizarMovimiento}
                />
        </ModalService>
    );
};

export default ModalEditMovimientos;